import { isRestrictedAudience } from "@/lib/postAudience";
// Profil privé (lot 522) : une publication personnelle d'un compte privé ne se partage pas (story, republication,
// lien, image) — sauf par son auteur. Miroir de privacy.post_share_locked côté serveur.
export const postShareLocked = (post, user) => {
  // Lot 649 — audience restreinte (Abonnés / Suivis / Moi…) : personne ne la fait sortir du cercle, l'auteur compris.
  if (isRestrictedAudience(post?.visibility) && !post?.as_church_id) return true;
  if (!post?.author?.is_private || post.as_church_id) return false;
  const authorId = post.author?.id || post.author_id;
  return !user || authorId !== user.id;
};
